import React from "react";
import PropTypes from "prop-types";
import { viewTypes } from '../../../constants/view-types';
import cx from 'classnames';

const FormSection = ({ title, children, viewType }) => {

  return (
    <div className={cx("FormSection", { "FormSection--doc": viewType === viewTypes.DOCUMENT })}>
      <div className="FormSection__title">
        {title}
      </div>

      <div className={cx({ "FormSection__children": viewType === viewTypes.PROJECT })}>
        {children}
      </div>
    </div>
  );
};

FormSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  viewType: PropTypes.string.isRequired,
};

export default FormSection;
